import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import translationFR from './locales/fr_FR.json';

const locales = ['fr'];
let defaultLanguage = "fr";

// the translations
const resources = {

  fr: {
    translation: translationFR
  },

  
};

i18n.use(LanguageDetector)
//.use(initReactI18next)  // passes i18n down to react-i18next
.init({
    resources,
    lng: defaultLanguage,
    locales,
    keySeparator:false,  // to support nested translations

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;